import React from 'react';

export default Component => (
  class withItemSearch extends React.Component {
    constructor() {
      super();

      this.state = {
        search: '',
      };
    }

    onSearch = (event) => {
      this.setState({ search: event.target.value });
    };

    render() {
      const { search } = this.state;
      const { items, ...rest } = this.props;
      const lowerCaseSearch = search.toLowerCase();

      return (
        <Component
          {...rest}
          items={items.filter(({ name }) => name.toLowerCase().includes(lowerCaseSearch))}
          search={search}
          onSearch={this.onSearch}
        />
      );
    }
  }
);
